module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noind",
    attrs: {
      "id": "part"
    }
  }, [_vm._v("The eight novels in this series, carrying the story of an American family forward from its beginning in Revolutionary times to the two-hundredth anniversary of the Republic, could only be dedicated, book by book, to the eight Americans I love best of all. And so, Rachel, this is for you.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-732b206c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/3-part.vue
// module id = 78
// module chunks = 0